<template lang="pug">
  .subscribe-and-save
    SectionTitle(text="Subscribe & Save").text-center
    product(:product-id="productId" v-slot="{ product }")
      template(v-if="product")
        HeroProduct(:product="product")
        SubscribeWithBenefits(:product="product")

</template>

<script>
  import SectionTitle from "../../../SectionTitle";
  import HeroProduct from "./HeroProduct";
  import SubscribeWithBenefits from "../../SubscribeWithBenefits";

  export default {
    name: "SubscribeAndSave",
    components: {
      SubscribeWithBenefits,
      HeroProduct,
      SectionTitle
    },

    props: {
      productId: {
        type: Number,
        required: true
      }
    }
   }
</script>

<style scoped lang="stylus">
  .subscribe-and-save
    .hero-product
      padding 0 1.5em 2em

    .section-title
      padding 1em

  @media mobile
    .subscribe-and-save
      .hero-product
        padding 0 0 2em

</style>
